import _regeneratorRuntime from "/home/vsts/work/1/s/Code/WebApp/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/vsts/work/1/s/Code/WebApp/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/Code/WebApp/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import * as tslib_1 from "tslib";
/**
 * @module GraphErrorHandler
 */

import { GraphError } from "./GraphError";
/**
 * @class
 * Class for GraphErrorHandler
 */

export var GraphErrorHandler =
/*#__PURE__*/
function () {
  function GraphErrorHandler() {
    _classCallCheck(this, GraphErrorHandler);
  }

  _createClass(GraphErrorHandler, null, [{
    key: "constructError",

    /**
     * @private
     * @static
     * Populates the GraphError instance with Error instance values
     * @param {Error} error - The error returned by graph service or some native error
     * @param {number} [statusCode] - The status code of the response
     * @returns The GraphError instance
     */
    value: function constructError(error, statusCode) {
      var gError = new GraphError(statusCode);

      if (error.name !== undefined) {
        gError.code = error.name;
      }

      gError.body = error.toString();
      gError.message = error.message;
      gError.date = new Date();
      return gError;
    }
    /**
     * @private
     * @static
     * @async
     * Populates the GraphError instance from the Error returned by graph service
     * @param {any} error - The error returned by graph service or some native error
     * @param {number} statusCode - The status code of the response
     * @returns A promise that resolves to GraphError instance
     *
     * Example error for https://graph.microsoft.com/v1.0/me/events?$top=3&$search=foo
     * {
     *      "error": {
     *          "code": "SearchEvents",
     *          "message": "The parameter $search is not currently supported on the Events resource.",
     *          "innerError": {
     *              "request-id": "b31c83fd-944c-4663-aa50-5d9ceb367e19",
     *              "date": "2016-11-17T18:37:45"
     *          }
     *      }
     *  }
     */

  }, {
    key: "constructErrorFromResponse",
    value: function constructErrorFromResponse(error, statusCode) {
      error = error.error;
      var gError = new GraphError(statusCode);
      gError.code = error.code;
      gError.message = error.message;

      if (error.innerError !== undefined) {
        gError.requestId = error.innerError["request-id"];
        gError.date = new Date(error.innerError.date);
      }

      try {
        gError.body = JSON.stringify(error);
      } catch (error) {// tslint:disable-line: no-empty
      }

      return gError;
    }
    /**
     * @public
     * @static
     * @async
     * To get the GraphError object
     * @param {any} [error = null] - The error returned by graph service or some native error
     * @param {number} [statusCode = -1] - The status code of the response
     * @param {GraphRequestCallback} [callback] - The graph request callback function
     * @returns A promise that resolves to GraphError instance
     */

  }, {
    key: "getError",
    value: function getError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var statusCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var gError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (error && error.error) {
                  gError = GraphErrorHandler.constructErrorFromResponse(error, statusCode);
                } else if (typeof Error !== "undefined" && error instanceof Error) {
                  gError = GraphErrorHandler.constructError(error, statusCode);
                } else {
                  gError = new GraphError(statusCode);
                }

                if (!(typeof callback === "function")) {
                  _context.next = 5;
                  break;
                }

                callback(gError, null);
                _context.next = 6;
                break;

              case 5:
                return _context.abrupt("return", gError);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return GraphErrorHandler;
}();